import { AlarmExceedancesRuntimeDataService } from './alarmExceedances/service';
import { AttributesRuntimeDataService } from './attributes/service';
import { CommentsRuntimeDataService } from './comments/service';
import { HighestReadingsRuntimeDataService } from './highestReadings/service';
import { LeqAlarmExceedancesRuntimeDataService } from './leqAlarmExceedances/service';
import { LmaxAlarmExceedancesRuntimeDataService } from './lmaxAlarmExceedances/service';
import { LdenValuesRuntimeDataService } from './ldenValues/ldenValuesService';
import { LxnValuesRuntimeDataService } from './lxnValues/service';
import { MeasurementSettingsRuntimeDataService } from './measurementSettings/service';
import { MeasuringPointContextRuntimeDataService } from './measuringPointContext/service';
import { ProjectMeasuringPointsRuntimeDataService } from './projectMeasuringPoints/service';
import { ProjectContextRuntimeDataService } from './projectContext/service';
import { ReportRuntimeDataService } from './report/service';
import { SystemAssetsRuntimeDataService } from './systemAssets/service';
import { TemplateOptionsRuntimeDataService } from './templateOptions/service';
import { TemplateResolveRuntimeDataService } from './templateResolve/service';
import type { RuntimeDataServiceClass } from './types';
import { VperPeriodsRuntimeDataService } from './vperPeriods/service';

export const RUNTIME_DATA_SERVICE_CLASSES = [
    ProjectContextRuntimeDataService,
    MeasuringPointContextRuntimeDataService,
    ReportRuntimeDataService,
    AttributesRuntimeDataService,
    // After attributes so binding choices list customer content first.
    SystemAssetsRuntimeDataService,
    AlarmExceedancesRuntimeDataService,
    CommentsRuntimeDataService,
    LeqAlarmExceedancesRuntimeDataService,
    LmaxAlarmExceedancesRuntimeDataService,
    LdenValuesRuntimeDataService,
    VperPeriodsRuntimeDataService,
    HighestReadingsRuntimeDataService,
    LxnValuesRuntimeDataService,
    MeasurementSettingsRuntimeDataService,
    ProjectMeasuringPointsRuntimeDataService,
    TemplateOptionsRuntimeDataService,
    TemplateResolveRuntimeDataService,
] as const satisfies readonly RuntimeDataServiceClass[];
